<div class="row">
  <div class="col-md-4">
    <h1>!!Status Works!!</h1>
    <hr>
    <br>
    <a [routerLink]="['/']" class="btn btn-primary">Home</a>
  </div>
</div>
